export class SocialNetworksModel {
  linkedIn: string="";
  facebook: string="";
  twitter: string="";
  instragram: string="";
}
